(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vPlatform-resource-29ee768144ce68cbddff76c0a39b52c9", [], factory);
	else if(typeof exports === 'object')
		exports["vPlatform-resource-29ee768144ce68cbddff76c0a39b52c9"] = factory();
	else
		root["vPlatform-resource-29ee768144ce68cbddff76c0a39b52c9"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "JkW7");
/******/ })
/************************************************************************/
/******/ ({

/***/ "2KSk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _v3platform = __webpack_require__("g9f8");

var _v3platform2 = _interopRequireDefault(_v3platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function genUUID() {
  function S4() {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
  }
  return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
}

/**
* 清除记录状态
* @params {Object} records 实体记录
*/
function clearRecordState(records) {
  if (records && records.length > 0) {
    for (var i = 0, len = records.length; i < len; i++) {
      var record = records[i];
      if (true === record._metadata_.isCurrent) {
        record._metadata_ = {
          isCurrent: false,
          isSelected: false,
          dsName: record._metadata_.dsName
        };
      }
    }
  }
  return record;
}
exports.default = {
  /**
   * 设置当前行
   * @param {Object} params
   * {
   *    record : {},//设置成当前行的数据
   *    entityRecords : []//实体全部数据
   * }
   */
  setCurrentRecord: function setCurrentRecord(params) {
    if (!params | !params.record) {
      return;
    }
    var instance = params.vueObj;
    if (instance) {
      var record = params.record;
      instance.markCurrent(record);
      // if(v3PlatformUtils.isRunInV3Service()){
      //   var dsName = record._metadata_.dsName;
      //   v3PlatformUtils.synCurrentRecordToDs(instance,dsName,record);
      // }
    } else if (params.entityRecords && params.entityRecords.length > 0) {
      var cId = params.record.id;
      if (!cId) throw new Error("无法读取记录的id属性，不能设置为当前行");
      /* 如果已经是当前行，就不设置了 */
      if (params.record._metadata_ && params.record._metadata_.isCurrent) return;
      var dsName = null;
      var errorRecord = [];
      var entityRecords = params.entityRecords;
      for (var i = 0, len = entityRecords.length; i < len; i++) {
        var record = entityRecords[i];
        if (undefined == record._metadata_) {
          throw new Error("实体记录存在非源数据的记录，请检查.");
        }
        if (cId == record.id) {
          record._metadata_ = {
            isCurrent: true,
            isSelected: true,
            dsName: record._metadata_.dsName
          };
          entityRecords.current = record;
        } else if (true === record._metadata_.isCurrent) {
          record._metadata_ = {
            isCurrent: false,
            isSelected: false,
            dsName: record._metadata_.dsName
          };
        }
      }
    }
  },
  /**
   * 获取所有选中记录
   * @return Array
   */
  getSelectedRecord: function getSelectedRecord(params) {
    var result = [];
    if ((typeof params === "undefined" ? "undefined" : _typeof(params)) == "object") {
      var vueObj = params.vueObj;
      var records = params.records;
      if (vueObj) {
        return vueObj.getSelectedRecords();
      }
      if (vueObj && records && records.length > 0) {
        var dsName = params.records[0]._metadata_.dsName;
        var rs = _v3platform2.default.getSelectedRecords(vueObj, dsName);
        if (rs && rs.length > 0) {
          var ids = [];
          for (var i = 0, len = rs.length; i < len; i++) {
            ids.push(rs[i].id);
          }
          for (var i = 0, len = records.length; i < len; i++) {
            var record = records[i];
            if (ids.indexOf(record.id) != -1) {
              result.push(record);
            }
          }
        }
      } else if (params.length > 0) {
        for (var i = 0, l = params.length; i < l; i++) {
          var record = params[i];
          var metadata = record._metadata_;
          if (metadata && metadata.isSelected) {
            result.push(record);
          }
        }
      }
    }
    return result;
  },
  /**
   * 获取当前行
   * @return Object
   */
  getCurrentRecord: function getCurrentRecord(params) {
    if ((typeof params === "undefined" ? "undefined" : _typeof(params)) == "object") {
      var vueObj = params.vueObj;
      var records = params.records;
      if (vueObj) {
        return vueObj.getCurrentRecord();
      }
      if (vueObj && records && records.length > 0) {
        var record = params.records[0];
        var dsName = record._metadata_.dsName;
        var rd = _v3platform2.default.getCurrentRecord(vueObj, dsName);
        if (rd) {
          for (var i = 0, len = records.length; i < len; i++) {
            var record = records[i];
            if (record.id == rd.id) {
              return record;
            }
          }
        }
      } else if (params.length > 0) {
        for (var i = 0, l = params.length; i < l; i++) {
          var rd = params[i];
          var metadata = rd._metadata_;
          if (metadata && true === metadata.isCurrent) {
            params.current = rd;
            return rd;
          }
        }
      }
    }
    return null;
  },
  /**
   * 设置选中记录
   * @param {Object} records 需要选中的记录
   * 
   */
  setSelectRecords: function setSelectRecords(params) {
    if ((typeof params === "undefined" ? "undefined" : _typeof(params)) == "object" && params.records && params.records.length > 0) {
      var vueObj = params.vueObj;
      var isSelect = params.isSelect === true ? true : false;
      var records = params.records;
      if (vueObj) {
        //使用实例提供的方法
        vueObj.markSelected(records);
        //var dsName = records[0]._metadata_.dsName;
        //v3PlatformUtils.synSelectRecordToDs(vueObj, dsName, params.records, isSelect);
      } else {
        for (var i = 0, len = records.length; i < len; i++) {
          var record = records[i];
          var _metadata_ = record._metadata_;
          if (_metadata_ && true != _metadata_.isSelected) {
            record._metadata_.isSelected = isSelect;
          }
        }
      }
    }
  },

  /**
   * 是否已选中
   */
  isSelected: function isSelected(params) {
    var vueObj = params.vueObj;
    if (vueObj && params.record) {
      return vueObj.isSelected(params.record);
      //var dsName = params.record._metadata_.dsName;
      //return v3PlatformUtils.isSelected(vueObj, dsName, params.record);
    } else {
      var metadata = params._metadata_;
      return metadata && metadata.isSelected;
    }
  },

  /**
   *是否当前行
  */
  isCurrent: function isCurrent(params) {
    var vueObj = params.vueObj;
    if (vueObj && params.record) {
      return vueObj.isCurrent(params.record);
      //var dsName = params.record._metadata_.dsName;
      //return v3PlatformUtils.isCurrent(vueObj, dsName, params.record);
    } else {
      var metadata = params._metadata_;
      return metadata && metadata.isCurrent;
    }
  },

  /**
  * 插入记录
  * @param {Object} params 实体记录
  * {
  *   'records':[],// 新增的实体数据
  *   'entityRecords':[]// 原来实体的数据
  * }
  */
  insertRecords: function insertRecords(params) {
    if (params && params.records) {
      var records = params.records;
      var currentRecord = {};
      for (var i = 0, len = records.length; i < len; i++) {
        var record = records[i];
        if (!record.id) {
          record.id = genUUID();
        }
        var isCurrent = i == len - 1 ? true : false;
        record._metadata_ = {
          isCurrent: isCurrent,
          isSelected: isCurrent
        };
        if (isCurrent) currentRecord = record;
      }
      var entityRecords = params.entityRecords;
      /* 清除记录状态 */
      if (entityRecords && entityRecords.length > 0) {
        clearRecordState(entityRecords);
      }
      entityRecords.push.apply(entityRecords, records);
      entityRecords.current = currentRecord;
    }
  },

  /**
  * 删除记录
  * @param {Obejct} params 实体记录
  * {
  *   'records':[],// 新增的实体数据
  *   'entityRecords':[]// 原来实体的数据
  * }
  */
  deleteRecords: function deleteRecords(params) {
    if (params && params.records && params.records.length > 0 && params.entityRecords && params.entityRecords.length > 0) {
      var currentId = null;
      var rIds = [];
      var records = params.records;
      for (var i = 0, len = records.length; i < len; i++) {
        var id = records[i].id;
        /* 删除的记录中是否包含选中记录 */
        if (records[i]._metadata_.isCurrent === true) {
          currentId = id;
        }
        rIds.push(id);
      }
      var entityRecords = params.entityRecords;
      for (var i = 0; i < entityRecords.length; i++) {
        var rId = entityRecords[i].id;
        if (rIds.indexOf(rId) != -1) {
          entityRecords.splice(i, 1);
          i--;
        }
      }
      if (currentId != null) {
        if (entityRecords.length > 0) {
          /* 清除记录状态 */
          clearRecordState(entityRecords);
          entityRecords[0]._metadata_ = {
            isCurrent: true,
            isSelected: true,
            dsName: entityRecords[0]._metadata_.dsName
          };
          entityRecords.current = entityRecords[0];
        } else {
          entityRecords.current = [];
        }
      }
    }
  },
  /**
  * 更新记录
  * @param {Obejct} params 实体记录
  * {
  *   'records':[],// 更新的实体数据
  *   'entityRecords':[]// 原来实体的数据
  * }
  */
  updateRecords: function updateRecords(params) {
    if (params && params.records && params.records.length > 0) {
      var records = params.records;
      var rId_datas = {};
      for (var i = 0, len = records.length; i < len; i++) {
        var data = records[i];
        rId_datas[data.id] = data;
      }
      var entityRecords = params.entityRecords;
      for (var i = 0, len = entityRecords.length; i < len; i++) {
        var data = entityRecords[i];
        if (rId_datas[data.id]) {
          var newRecord = rId_datas[data.id];
          for (var key in newRecord) {
            if (key != "_metadata_" && newRecord.hasOwnProperty(key)) {
              data[key] = newRecord[key];
            }
          }
        }
      }
    }
  },
  /**
  * 重置实体记录字段数据为null
  * @param {Array} records 记录列表
  */
  clearRecordDatas: function clearRecordDatas(records) {
    if (undefined != records && records.length > 0) {
      for (var i = 0, len = records.length; i < len; i++) {
        var record = records[i];
        if (record) {
          for (var key in record) {
            if (record.hasOwnProperty(key) && key != "id" && key != "_metadata_") {
              record[key] = null;
            }
          }
        }
      }
    }
  },
  markMultipleDs: function markMultipleDs(params) {
    var dsName;
    var vueObj = params.vueObj;
    var records = params.records;
    if (vueObj) {
      vueObj.markDatasourceMultipleSelect();
      // if(records._metadata_){
      //   dsName = records._metadata_.dsName;
      // }else if(records.length > 0 && records[0]._metadata_){
      //   dsName = records[0]._metadata_.dsName;
      // }
      // if(dsName){
      //   v3PlatformUtils.markMultipleDs(vueObj, dsName);
      // }
    }
  }

};

/***/ }),

/***/ "ATBs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {

    _toLoadVjsList: [],

    _loadingVjsList: [],

    readyToLoad: true,

    _isRunInV3Service: function _isRunInV3Service() {
        return window.VMetrix && window.VMetrix.loadBundles;
    },

    /**
     * 获取窗体域
     */
    _getWindowScope: function _getWindowScope() {
        var scopeStack = window.VPlatformScope;
        if (scopeStack && scopeStack.length > 0) {
            return scopeStack[scopeStack.length - 1];
        }
        return null;
    },

    /**
     * @param {Array} vjsList 加载的vjs列表
     * @return {Promise}
     */
    loadVjs: function loadVjs(vjsList) {
        var _this = this;

        return new Promise(function (resolve, reject) {
            if (_this._isRunInV3Service()) {
                _this._toLoadVjsList.push({
                    vjsList: vjsList,
                    resolve: resolve,
                    reject: reject
                });
                if (_this.readyToLoad) {
                    setTimeout(function () {
                        var _VMetrix = window.VMetrix;
                        var vjs = [];
                        for (var i = 0, l = _this._toLoadVjsList.length; i < l; i++) {
                            var item = _this._toLoadVjsList[i];
                            _this._loadingVjsList.push(item);
                            var _vjsList = item.vjsList;
                            _vjsList = typeof _vjsList == 'string' ? [_vjsList] : _vjsList;
                            for (var j = 0, len = _vjsList.length; j < len; j++) {
                                var vjsName = _vjsList[j];
                                if (vjs.indexOf(vjsName) == -1) {
                                    vjs.push(vjsName);
                                }
                            }
                        }
                        _this._toLoadVjsList = [];
                        var sandbox = _VMetrix.sandbox.create({
                            extensions: vjs
                        });
                        sandbox.active().done(function () {
                            _this.readyToLoad = true;
                            for (var _i = 0, _l = _this._loadingVjsList.length; _i < _l; _i++) {
                                var _item = _this._loadingVjsList[_i];
                                _item.resolve(sandbox);
                            }
                            _this._loadingVjsList = [];
                        }, function (err) {
                            _this.readyToLoad = true;
                            for (var _i2 = 0, _l2 = _this._loadingVjsList.length; _i2 < _l2; _i2++) {
                                var _item2 = _this._loadingVjsList[_i2];
                                _item2.reject(err);
                            }
                            _this._loadingVjsList = [];
                        });
                    }, 1);
                }
                _this.readyToLoad = false;
            } else {
                reject(new Error("未运行在V3服务内，无法执行操作."));
            }
        });
    },

    /**
     * @param {Array}       vjsList 加载的vjs列表
     * @param {Function}    success 加载成功的回调，入参是sandbox
     * @param {Function}    error   加载失败的回调
     */
    loadVjsSync: function loadVjsSync(vjsList, success, error) {
        if (this._isRunInV3Service()) {
            var _VMetrix = window.VMetrix;
            var sandbox = _VMetrix.sandbox.create({
                extensions: vjsList
            });
            sandbox.active().done(function () {
                if (typeof success == "function") success(sandbox);
            }, function (err) {
                if (typeof error == "function") error(err);
            });
        } else {
            throw Error("未运行在V3服务内，无法执行操作.");
        }
    },


    /**
     * 参数是否给定
     * @param {Object} params 
     * @param {string} key 
     */
    assertParamDef: function assertParamDef(params, key) {
        return params && params.hasOwnProperty(key) ? true : false;
    },


    /**
     * 参数值不为null
     * @param {Object} params 
     * @param {string} key 
     */
    assertNotNull: function assertNotNull(params, key) {
        if (this.assertParamDef(params, key)) {
            var val = params[key];
            return val !== null && typeof val != 'undefined';
        }
        return false;
    }
};

/***/ }),

/***/ "Anbr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Utils = __webpack_require__("ATBs");

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isWechat() {
	var ua = navigator.userAgent.toLowerCase();
	if (ua.match(/MicroMessenger/i) == "micromessenger") {
		return true;
	} else {
		return false;
	}
}

function isDingDing() {
	var ua = navigator.userAgent;
	if (ua.match(/DingTalk/i) == "DingTalk") {
		return true;
	} else {
		return false;
	}
}

function isAndroid() {
	var ua = navigator.userAgent;
	if (ua.match(/Android/i) == "Android") {
		return true;
	} else {
		return false;
	}
}

function isYdgApp() {
	var ua = navigator.userAgent;
	if (ua.match(/ydgApp/i) == "ydgApp") {
		return true;
	} else {
		return false;
	}
}

exports.default = {

	mediaCapture: {

		/**
   * 拍摄视频
   */
		captureVideo: function captureVideo(successCallback, errorCallback) {
			var vjsList = ['vjs.framework.extension.platform.services.native.mobile.mediacapture'];
			var promise = _Utils2.default.loadVjs(vjsList);
			promise.then(function (sb) {
				var Mediacapture = sb.getService("vjs.framework.extension.platform.services.native.mobile.Mediacapture");
				if (Mediacapture) {
					var cb = function cb(videoObj) {
						if (videoObj.length > 0 && "string" == typeof videoObj[0].fullPath) {
							successCallback(videoObj[0].fullPath);
						} else {
							errorCallback("获取视频路径失败");
						}
					};
					Mediacapture.captureVideo(cb, errorCallback);
				} else {
					alert("请在移动端使用拍摄视频服务");
				}
			}).catch(function (err) {
				errorCallback(err);
			});
		}
	},

	imagePicker: {

		/**
   * 从相册选择文件
   */
		getPicture: function getPicture(successCallback, errorCallback, options) {
			if (!options.maximumImagesCount) {
				options.maximumImagesCount = 9;
			}
			if (isWechat()) {
				var vjsList = ['vjs.framework.extension.platform.services.native.mobile.image', 'vjs.framework.extension.platform.native.weixin.image', 'vjs.framework.extension.platform.services.domain.weixin.sdk.config'];
				var promise = _Utils2.default.loadVjs(vjsList);
				promise.then(function (sb) {
					var imageService = sb.getService("vjs.framework.extension.platform.services.native.mobile.Image");
					if (imageService) {
						imageService.chooseImage({
							sizeType: ['compressed'],
							count: options.maximumImagesCount,
							sourceType: ['album'],
							successCallback: successCallback
						});
					} else {
						alert("请在微信端使用拍照服务");
					}
				}).catch(function (err) {
					errorCallback(err);
				});
			} else {
				var vjsList = ['vjs.framework.extension.platform.services.native.mobile.imagepicker'];
				var _promise = _Utils2.default.loadVjs(vjsList);
				_promise.then(function (sb) {
					var ImagePicker = sb.getService("vjs.framework.extension.platform.services.native.mobile.ImagePicker");
					if (ImagePicker) {
						ImagePicker.getPicture(successCallback, errorCallback, options);
					} else {
						alert("请在移动端使用相册选择服务");
					}
				}).catch(function (err) {
					errorCallback(err);
				});
			}
		}
	},

	camera: {

		/**
   * 拍照
   */
		getPicture: function getPicture(successCallback, errorCallback, options) {
			if (!options.maximumImagesCount) {
				options.maximumImagesCount = 9;
			}
			if (isWechat()) {
				var vjsList = ['vjs.framework.extension.platform.services.native.mobile.image', 'vjs.framework.extension.platform.native.weixin.image', 'vjs.framework.extension.platform.services.domain.weixin.sdk.config'];
				var promise = _Utils2.default.loadVjs(vjsList);
				promise.then(function (sb) {
					var imageService = sb.getService("vjs.framework.extension.platform.services.native.mobile.Image");
					if (imageService) {
						var tmpCallback = function tmpCallback(imageids) {
							if (imageids && imageids.length > 0) successCallback(imageids[0]);else {
								errorCallback("拍照被取消");
							}
						};
						imageService.chooseImage({
							count: options.maximumImagesCount,
							sizeType: ['compressed'],
							sourceType: ['camera'],
							successCallback: tmpCallback
						});
					} else {
						alert("请在微信端使用拍照服务");
					}
				}).catch(function (err) {
					errorCallback(err);
				});
			} else {
				var vjsList = ['vjs.framework.extension.platform.services.native.mobile.camera'];
				var _promise2 = _Utils2.default.loadVjs(vjsList);
				_promise2.then(function (sb) {
					var Camera = sb.getService("vjs.framework.extension.platform.services.native.mobile.Camera");
					if (Camera) {
						Camera.getPicture(successCallback, errorCallback, options);
					} else {
						alert("请在移动端使用拍照服务");
					}
				}).catch(function (err) {
					errorCallback(err);
				});
			}
		}
	},

	fileUpload: {
		upload: function upload(browse_button, successCB, errorCB, config) {
			if (isDingDing() && isAndroid() && config && config.useCamera && "image/*" == config.fileMimeType) {
				vjsList = ["vjs.framework.extension.platform.native.dingding.filetransfer"];
				var promise = _Utils2.default.loadVjs(vjsList);
				promise.then(function (sb) {
					var h5Filetransfer = sb.getService("vjs.framework.extension.platform.service.native.dingding.Filetransfer");
					if (h5Filetransfer) {
						h5Filetransfer.uploadFiles(browse_button, successCB, config);
					} else {
						alert("加载vjs【vjs.framework.extension.platform.native.h5.filetransfer】失败,请检查");
					}
				}).catch(function (err) {
					errorCB(err);
				});
			} else {
				var vjsList = ["vjs.framework.extension.platform.native.h5.filetransfer"];
				var _promise3 = _Utils2.default.loadVjs(vjsList);
				_promise3.then(function (sb) {
					var h5Filetransfer = sb.getService("vjs.framework.extension.platform.native.h5.Filetransfer");
					if (h5Filetransfer) {
						h5Filetransfer.uploadFiles(browse_button, successCB, config);
					} else {
						alert("加载vjs【vjs.framework.extension.platform.native.h5.filetransfer】失败,请检查");
					}
				}).catch(function (err) {
					errorCB(err);
				});
			}
		}
	},

	fileTransfer: {

		/**
      * 文件上传
      * @param context vue实例对象
      */
		filetransferUpload: function filetransferUpload(fileUrls, callback, context) {
			var vjsList = [];
			if (isWechat()) {
				vjsList = ['vjs.framework.extension.platform.native.weixin.filetransfer'];
			} else {
				vjsList = ['vjs.framework.extension.platform.services.native.mobile.fileoperation'];
			}
			var promise = _Utils2.default.loadVjs(vjsList);
			promise.then(function (sb) {
				var FileTransfer;
				if (isWechat()) {
					FileTransfer = sb.getService("vjs.framework.extension.platform.native.weixin.Filetransfer");
				} else {
					FileTransfer = sb.getService("vjs.framework.extension.platform.services.native.mobile.FileTransfer");
				}
				if (FileTransfer) {
					var cb = function cb(success, fileInfos) {
						var successObj = {
							success: true,
							errorCode: 0
						};
						if (!success) {
							successObj.success = false;
							successObj.errorCode = 2;
						} else if (success && success.errorCode) {
							callback(success, fileInfos);
						} else {
							callback(successObj, fileInfos);
						}
					};
					if (isWechat()) {
						var scopeId = null;
						if (context) {
							scopeId = context.$root._$getScopeId();
						}
						FileTransfer.uploadFiles(fileUrls, cb, scopeId);
					} else {
						FileTransfer.filetransferUpload(fileUrls, cb);
					}
				} else {
					alert("请在移动端使用文件上传服务");
				}
			}).catch(function (err) {
				alert("App端文件上传失败：" + err);
			});
		}
	},

	geoLocation: {

		/**
   * 获取当前地理位置
   * @param config 可选参数。格式：
   * {
   * 	baiduMapAK: "百度地图AK码" ,//在非https页面下，用于调用百度地图的ip定位api。
   * }
   */
		getCurrentPosition: function getCurrentPosition(successCallBack, errorCallBack, config) {
			if (isYdgApp()) {
				var vjsList = ['vjs.framework.extension.platform.services.native.mobile.geolocation'];
				var promise = _Utils2.default.loadVjs(vjsList);
				promise.then(function (sb) {
					var Geolocation = sb.getService("vjs.framework.extension.platform.services.native.mobile.Geolocation");
					if (Geolocation) {
						var successCB = function successCB(positionInfo) {
							var latitudeTmp = positionInfo.coords.latitude;
							var longitudeTmp = positionInfo.coords.longitude;
							var rs = {
								latitude: latitudeTmp,
								longitude: longitudeTmp
							};
							successCallBack(rs);
						};
						Geolocation.getCurrentPosition(successCB, errorCallBack);
					}
				}).catch(function (err) {
					errorCallback(err);
				});
			} else {
				var vjsList;
				if (isDingDing()) {
					vjsList = ['vjs.framework.extension.platform.native.dingding.geolocation'];
				} else if (isWechat()) {
					vjsList = ['vjs.framework.extension.platform.native.weixin.geolocation'];
				} else {
					vjsList = ['vjs.framework.extension.platform.native.h5.geolocation'];
				}
				var _promise4 = _Utils2.default.loadVjs(vjsList);
				_promise4.then(function (sb) {
					var Geolocation = sb.getService("vjs.framework.extension.platform.service.native.mobile.Geolocation");
					if (Geolocation) {
						var successCB = function successCB(positionInfo) {
							var latitudeTmp = positionInfo.coords.latitude;
							var longitudeTmp = positionInfo.coords.longitude;
							var rs = {
								latitude: latitudeTmp,
								longitude: longitudeTmp
							};
							successCallBack(rs);
						};
						Geolocation.getCurrentPosition(successCB, errorCallBack, config);
					} else {
						//正常来说，不会进入这个分支。
						alert("内部错误，请联系管理员");
						errorCallback("内部错误，请联系管理员");
					}
				}).catch(function (err) {
					errorCallback(err);
				});
			}
		}
	},

	sdkConfig: {
		getDingTalkConfigObject: function getDingTalkConfigObject(apiList, successCB, errorCB) {
			if (isDingDing()) {
				var vjsList = ['vjs.framework.extension.platform.native.dingding.sdk.config'];
				var promise = _Utils2.default.loadVjs(vjsList);
				promise.then(function (sb) {
					var sdkConfig = sb.getService("vjs.framework.extension.platform.service.native.sdk.config");
					if (sdkConfig) {
						sdkConfig.initConfig(successCB, errorCB, apiList);
					} else {
						if (typeof errorCB == "function") errorCB("请在移动端使用本接口");
					}
				}).catch(function (err) {
					errorCallback(err);
				});
			}
		},
		getServerAddr: function getServerAddr() {
			if (window.VPlatformPatch && window.cordova) {
				var platformId = cordova.platformId;
				if (platformId == "ios") {
					return VPlatformPatch.getMetadata().serveraddr;
				} else {
					return VPlatformPatch.getMetadata().serverAddr;
				}
			} else {
				alert("请在App中使用本接口");
				return "";
			}
		}
	},
	network: {
		getNetworkState: function getNetworkState(successCB, errorCB) {
			var vjsList;
			if (isDingDing()) {
				vjsList = ['vjs.framework.extension.platform.native.dingding.network'];
			} else if (isWechat()) {
				vjsList = ['vjs.framework.extension.platform.native.weixin.network'];
			} else {
				vjsList = ['vjs.framework.extension.platform.native.cordova.network'];
			}
			var promise = _Utils2.default.loadVjs(vjsList);
			promise.then(function (sb) {
				var networkService = sb.getService("vjs.framework.extension.platform.service.native.Network");
				networkService.getNetworkState(successCB, errorCB);
			});
		},
		registerNetworkStateListener: function registerNetworkStateListener(listener) {
			var vjsList;
			if (isDingDing()) {
				vjsList = ['vjs.framework.extension.platform.native.dingding.network'];
			} else if (isWechat()) {
				vjsList = ['vjs.framework.extension.platform.native.weixin.network'];
			} else {
				vjsList = ['vjs.framework.extension.platform.native.cordova.network'];
			}
			var promise = _Utils2.default.loadVjs(vjsList);
			promise.then(function (sb) {
				var networkService = sb.getService("vjs.framework.extension.platform.service.native.Network");
				networkService.registerNetworkStateListener(listener);
			});
		}
	}

};

/***/ }),

/***/ "HaNs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GLOBALCTX = window || undefined;

/**
 * 获取全局数据仓库
 */
function getStore() {
    if (!GLOBALCTX._$V3GlobalDataStore$_) {
        GLOBALCTX._$V3GlobalDataStore$_ = {};
    }
    return GLOBALCTX._$V3GlobalDataStore$_;
}
/**
 * 添加全局数据，如果key值已存在，则报错
 * @param   {String} key
 * @param   {Object} val
 */
function put(key, val) {
    var store = getStore();
    if (store.hasOwnProperty(key)) {
        throw new Error("全局数据已存在key: " + key + ", 请检查.");
    } else {
        store[key] = val;
    }
}
/**
 * 根据key获取数据
 * @param {String} key 
 */
function get(key) {
    var store = getStore();
    return store[key];
}
/**
 * 添加全局数据
 * @param   {String} key
 * @param   {Object} val
 */
function meger(key, val) {
    var store = getStore();
    store[key] = val;
}
/**
 * 判断key是否存在
 * @param {String} key 
 * @returns {Boolean} true表示存在key，false表示不存在key
 */
function exists(key) {
    var store = getStore();
    return store.hasOwnProperty(key);
}

exports.default = {
    put: put,
    get: get,
    meger: meger,
    exists: exists,
    datas: getStore()
};

/***/ }),

/***/ "JkW7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Datasource = __webpack_require__("2KSk");

var _Datasource2 = _interopRequireDefault(_Datasource);

var _Window = __webpack_require__("dThJ");

var _Window2 = _interopRequireDefault(_Window);

var _Global = __webpack_require__("HaNs");

var _Global2 = _interopRequireDefault(_Global);

var _Webapi = __webpack_require__("fTHo");

var _Webapi2 = _interopRequireDefault(_Webapi);

var _V3Vue = __webpack_require__("vn7Q");

var _V3Vue2 = _interopRequireDefault(_V3Vue);

var _v3platform = __webpack_require__("g9f8");

var _v3platform2 = _interopRequireDefault(_v3platform);

var _Resource = __webpack_require__("Vcb0");

var _Resource2 = _interopRequireDefault(_Resource);

var _Mobile = __webpack_require__("Anbr");

var _Mobile2 = _interopRequireDefault(_Mobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  ds: _Datasource2.default,
  win: _Window2.default,
  page: _Window2.default,
  GLOBAL: _Global2.default,
  webapi: _Webapi2.default,
  vue: _V3Vue2.default,
  v3platform: _v3platform2.default,
  res: _Resource2.default,
  mobile: _Mobile2.default
};

/***/ }),

/***/ "RYcG":
/***/ (function(module, exports) {

module.exports = {"O_RDONLY":0,"O_WRONLY":1,"O_RDWR":2,"S_IFMT":61440,"S_IFREG":32768,"S_IFDIR":16384,"S_IFCHR":8192,"S_IFBLK":24576,"S_IFIFO":4096,"S_IFLNK":40960,"S_IFSOCK":49152,"O_CREAT":512,"O_EXCL":2048,"O_NOCTTY":131072,"O_TRUNC":1024,"O_APPEND":8,"O_DIRECTORY":1048576,"O_NOFOLLOW":256,"O_SYNC":128,"O_SYMLINK":2097152,"O_NONBLOCK":4,"S_IRWXU":448,"S_IRUSR":256,"S_IWUSR":128,"S_IXUSR":64,"S_IRWXG":56,"S_IRGRP":32,"S_IWGRP":16,"S_IXGRP":8,"S_IRWXO":7,"S_IROTH":4,"S_IWOTH":2,"S_IXOTH":1,"E2BIG":7,"EACCES":13,"EADDRINUSE":48,"EADDRNOTAVAIL":49,"EAFNOSUPPORT":47,"EAGAIN":35,"EALREADY":37,"EBADF":9,"EBADMSG":94,"EBUSY":16,"ECANCELED":89,"ECHILD":10,"ECONNABORTED":53,"ECONNREFUSED":61,"ECONNRESET":54,"EDEADLK":11,"EDESTADDRREQ":39,"EDOM":33,"EDQUOT":69,"EEXIST":17,"EFAULT":14,"EFBIG":27,"EHOSTUNREACH":65,"EIDRM":90,"EILSEQ":92,"EINPROGRESS":36,"EINTR":4,"EINVAL":22,"EIO":5,"EISCONN":56,"EISDIR":21,"ELOOP":62,"EMFILE":24,"EMLINK":31,"EMSGSIZE":40,"EMULTIHOP":95,"ENAMETOOLONG":63,"ENETDOWN":50,"ENETRESET":52,"ENETUNREACH":51,"ENFILE":23,"ENOBUFS":55,"ENODATA":96,"ENODEV":19,"ENOENT":2,"ENOEXEC":8,"ENOLCK":77,"ENOLINK":97,"ENOMEM":12,"ENOMSG":91,"ENOPROTOOPT":42,"ENOSPC":28,"ENOSR":98,"ENOSTR":99,"ENOSYS":78,"ENOTCONN":57,"ENOTDIR":20,"ENOTEMPTY":66,"ENOTSOCK":38,"ENOTSUP":45,"ENOTTY":25,"ENXIO":6,"EOPNOTSUPP":102,"EOVERFLOW":84,"EPERM":1,"EPIPE":32,"EPROTO":100,"EPROTONOSUPPORT":43,"EPROTOTYPE":41,"ERANGE":34,"EROFS":30,"ESPIPE":29,"ESRCH":3,"ESTALE":70,"ETIME":101,"ETIMEDOUT":60,"ETXTBSY":26,"EWOULDBLOCK":35,"EXDEV":18,"SIGHUP":1,"SIGINT":2,"SIGQUIT":3,"SIGILL":4,"SIGTRAP":5,"SIGABRT":6,"SIGIOT":6,"SIGBUS":10,"SIGFPE":8,"SIGKILL":9,"SIGUSR1":30,"SIGSEGV":11,"SIGUSR2":31,"SIGPIPE":13,"SIGALRM":14,"SIGTERM":15,"SIGCHLD":20,"SIGCONT":19,"SIGSTOP":17,"SIGTSTP":18,"SIGTTIN":21,"SIGTTOU":22,"SIGURG":16,"SIGXCPU":24,"SIGXFSZ":25,"SIGVTALRM":26,"SIGPROF":27,"SIGWINCH":28,"SIGIO":23,"SIGSYS":12,"SSL_OP_ALL":2147486719,"SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION":262144,"SSL_OP_CIPHER_SERVER_PREFERENCE":4194304,"SSL_OP_CISCO_ANYCONNECT":32768,"SSL_OP_COOKIE_EXCHANGE":8192,"SSL_OP_CRYPTOPRO_TLSEXT_BUG":2147483648,"SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS":2048,"SSL_OP_EPHEMERAL_RSA":0,"SSL_OP_LEGACY_SERVER_CONNECT":4,"SSL_OP_MICROSOFT_BIG_SSLV3_BUFFER":32,"SSL_OP_MICROSOFT_SESS_ID_BUG":1,"SSL_OP_MSIE_SSLV2_RSA_PADDING":0,"SSL_OP_NETSCAPE_CA_DN_BUG":536870912,"SSL_OP_NETSCAPE_CHALLENGE_BUG":2,"SSL_OP_NETSCAPE_DEMO_CIPHER_CHANGE_BUG":1073741824,"SSL_OP_NETSCAPE_REUSE_CIPHER_CHANGE_BUG":8,"SSL_OP_NO_COMPRESSION":131072,"SSL_OP_NO_QUERY_MTU":4096,"SSL_OP_NO_SESSION_RESUMPTION_ON_RENEGOTIATION":65536,"SSL_OP_NO_SSLv2":16777216,"SSL_OP_NO_SSLv3":33554432,"SSL_OP_NO_TICKET":16384,"SSL_OP_NO_TLSv1":67108864,"SSL_OP_NO_TLSv1_1":268435456,"SSL_OP_NO_TLSv1_2":134217728,"SSL_OP_PKCS1_CHECK_1":0,"SSL_OP_PKCS1_CHECK_2":0,"SSL_OP_SINGLE_DH_USE":1048576,"SSL_OP_SINGLE_ECDH_USE":524288,"SSL_OP_SSLEAY_080_CLIENT_DH_BUG":128,"SSL_OP_SSLREF2_REUSE_CERT_TYPE_BUG":0,"SSL_OP_TLS_BLOCK_PADDING_BUG":512,"SSL_OP_TLS_D5_BUG":256,"SSL_OP_TLS_ROLLBACK_BUG":8388608,"ENGINE_METHOD_DSA":2,"ENGINE_METHOD_DH":4,"ENGINE_METHOD_RAND":8,"ENGINE_METHOD_ECDH":16,"ENGINE_METHOD_ECDSA":32,"ENGINE_METHOD_CIPHERS":64,"ENGINE_METHOD_DIGESTS":128,"ENGINE_METHOD_STORE":256,"ENGINE_METHOD_PKEY_METHS":512,"ENGINE_METHOD_PKEY_ASN1_METHS":1024,"ENGINE_METHOD_ALL":65535,"ENGINE_METHOD_NONE":0,"DH_CHECK_P_NOT_SAFE_PRIME":2,"DH_CHECK_P_NOT_PRIME":1,"DH_UNABLE_TO_CHECK_GENERATOR":4,"DH_NOT_SUITABLE_GENERATOR":8,"NPN_ENABLED":1,"RSA_PKCS1_PADDING":1,"RSA_SSLV23_PADDING":2,"RSA_NO_PADDING":3,"RSA_PKCS1_OAEP_PADDING":4,"RSA_X931_PADDING":5,"RSA_PKCS1_PSS_PADDING":6,"POINT_CONVERSION_COMPRESSED":2,"POINT_CONVERSION_UNCOMPRESSED":4,"POINT_CONVERSION_HYBRID":6,"F_OK":0,"R_OK":4,"W_OK":2,"X_OK":1,"UV_UDP_REUSEADDR":4}

/***/ }),

/***/ "Vcb0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @author xujw 2018-8-27 16:08:07
 * 控件资源路径动态生成
 */

/**
 * 获取控件资源路径
 * @param {String} widgetCode 控件编码
 * @param {String} relativePath 相对路径
 */
var depLibsDir = "dependencies";

function getWidgetResPath(widgetCode, pluginType, relativePath) {
    // 执行系统资源前缀
    var runtime_prefix = 'itop/common/extension/custom';
    var resurl = relativePath;
    var pathFlag = relativePath.split('/');
    var fileName = pathFlag[pathFlag.length - 1];
    /* 如果为执行系统环境则生成执行系统环境地址 */
    if (typeof window._$v3platform_runtime_env != 'undefined' && window._$v3platform_runtime_env) {
        resurl = runtime_prefix + '/' + pluginType + '/' + widgetCode + '/' + fileName;
    } else if (typeof GlobalVariables != 'undefined') {
        var serverUrl = GlobalVariables.getServerUrl();
        resurl = serverUrl + '/' + runtime_prefix + '/' + pluginType + '/' + widgetCode + '/' + fileName;
    } else if (typeof window._$v3platform_preview_env != 'undefined' && window._$v3platform_preview_env) {
        resurl = depLibsDir + '/' + widgetCode + '/' + relativePath.substring(relativePath.indexOf('/'));
    }
    return resurl;
}

exports.default = {
    getWidgetResPath: getWidgetResPath
};

/***/ }),

/***/ "dThJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _Utils = __webpack_require__("ATBs");

var _Utils2 = _interopRequireDefault(_Utils);

var _v3platform = __webpack_require__("g9f8");

var _v3platform2 = _interopRequireDefault(_v3platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 根据上下文获取域id
 * @param {Object} context vue实例对象
 */
function getScopeIdFromContext(context) {
    return context && context && context.$root && typeof context.$root._$getScopeId == "function" ? context.$root._$getScopeId() : null;
}
/**
 * 错误消息处理服务
 */
var errorMsgHandlerServivce;
/**
 * 
 * @param {Object/String} message 异常消息
 */
function showError(message) {
    var cb = function cb(sandbox) {
        throw new Error(message);
    };
    if (!errorMsgHandlerServivce) {
        var vjsList = ['vjs.framework.extension.platform.services.browser', "vjs.framework.extension.platform.interface.scope"];
        var promise = _Utils2.default.loadVjs(vjsList);
        promise.then(function (sandbox) {
            cb();
        });
    } else {
        cb(errorMsgHandlerServivce);
    }
}

exports.default = {

    /**
     * 重定向到指定窗体(当前页面跳转)
     */
    redirectTo: function redirectTo(params) {
        if (!params || !params.componentCode || !params.windowCode) {
            throw Error("构件编码或者窗体编码为空, 无法跳转.");
        }
        this.render({
            type: "currentContainer",
            componentCode: params.componentCode,
            windowCode: params.windowCode,
            params: params.params,
            context: params.context
        });
    },

    /**
     * 保留当前页面，跳转到应用内的某个页面（模态窗体打开）
     * @param {Object} params 
     */
    navigateTo: function navigateTo(params) {},

    /**
     * 关闭当前页面，返回上一页面
     * @param {Object} params 
     */
    navigateBack: function navigateBack(params) {},


    /**
     * 获取窗体入参
     */
    getParam: function getParam(params) {
        var key;
        var context;
        if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) == "object") {
            key = params.key;
            context = params.context;
        } else {
            key = params;
        }
        var value = undefined;
        var vjsList = ["vjs.framework.extension.platform.data.storage.runtime.param", "vjs.framework.extension.platform.interface.scope"];
        var sandbox = undefined;
        var success = function success(sBox) {
            sandbox = sBox;
        };
        _Utils2.default.loadVjsSync(vjsList, success);
        var windowParam = sandbox.getService("vjs.framework.extension.platform.data.storage.runtime.param.WindowParam");
        var ScopeManager = sandbox.getService("vjs.framework.extension.platform.interface.scope.ScopeManager");
        var scopeId = context && context && context.$root && typeof context.$root._$getScopeId == "function" ? context.$root._$getScopeId() : null;
        if (windowParam) {
            value = ScopeManager.createScopeHandler({
                scopeId: scopeId,
                handler: function handler(wp) {
                    return wp.getInput(key);
                }
            })(windowParam);
        }
        return value;
    },


    /**
     * 渲染窗体
     * @param {Object} params 
     * {
     *  componentCode : '构件编码',
     *  windowCode : '窗体编码',
     *  title : '窗体标题',
     *  context:{},
     *  params : {},//窗体输入参数
     *  type : '',//打开方式：currentContainer（当前容器跳转）currentWindow（当前浏览器跳转）newWindow（新窗体打开）
     *  success : function(){},//成功回调
     *  fail : function(){}//失败回调
     * }
     */
    render: function render(params) {
        if (!params) {
            console.warn("参数无效，已忽略.");
            return;
        }
        var componentCode = params.componentCode;
        var windowCode = params.windowCode;
        var variable = params.params ? params.params : {};
        var windowInputParams = {
            "variable": variable
        };
        var success = params.success;
        var error = params.fail;
        var title = params.title;
        var context = params.context;
        var openFunc;
        switch (params.type) {
            case "currentContainer":
                windowInputParams.variable.formulaOpenMode = "locationHref";
                openFunc = function openFunc(params) {
                    params.browser.redirectModule({
                        "componentCode": params.componentCode,
                        "windowCode": params.windowCode,
                        "params": {
                            inputParam: params.windowInputParams
                        }
                    });
                };
                break;
            case "currentWindow":
                openFunc = function openFunc(params) {
                    params.browser.redirectLocation({
                        "componentCode": params.componentCode,
                        "windowCode": params.windowCode,
                        "title": params.title,
                        "inputParam": params.windowInputParams
                    });
                };
                break;
            case "newWindow":
                windowInputParams.variable.formulaOpenMode = "dialog";
                openFunc = function openFunc(params) {
                    params.browser.callBrowserWindow({
                        "componentCode": params.componentCode,
                        "windowCode": params.windowCode,
                        "title": params.title,
                        "inputParam": params.windowInputParams,
                        "isBlock": false,
                        "winName": "_blank"
                    });
                };
                break;
            default:
                throw new Error("不支持这种打开方式: " + params.type);
        }
        var vjsList = ['vjs.framework.extension.platform.services.browser', "vjs.framework.extension.platform.interface.scope"];
        var promise = _Utils2.default.loadVjs(vjsList);
        var scopeId = context && context.$root && typeof context.$root._$getScopeId == "function" ? context.$root._$getScopeId() : null;
        promise.then(function (sb) {
            var browser = sb.getService("vjs.framework.extension.platform.services.browser.Browser");
            if (browser) {
                var ScopeMananger = sb.getService("vjs.framework.extension.platform.interface.scope.ScopeManager");
                if (typeof openFunc == 'function') {
                    var _p = {
                        componentCode: componentCode,
                        windowCode: windowCode,
                        title: title,
                        windowInputParams: windowInputParams,
                        browser: browser
                    };
                    ScopeMananger.createScopeHandler({
                        scopeId: scopeId,
                        handler: openFunc
                    })(_p);
                    /*
                    openFunc({
                        componentCode : componentCode,
                        windowCode : windowCode,
                        title : title,
                        windowInputParams : windowInputParams,
                        browser : browser
                    });
                    */
                }
            }
        }).catch(function (err) {
            error(err);
        });
    },

    /**
     * 渲染窗体到指定元素
     * @param {Object} params 
     * {
     *  componentCode : '构件编码',
     *  windowCode : '窗体编码',
     *  context:{},//vue实例对象
     *  el:Dom元素的id值或者元素对象
     *  params : {},//窗体输入参数
     *  success : function(){},//成功回调
     *  fail : function(){}//失败回调
     * }
     */
    redirectToElement: function redirectToElement(params) {
        if (!params) {
            return;
        }
        var componentCode = params.componentCode;
        var windowCode = params.windowCode;
        var context = params.context;
        var el = params.el;
        var fail = params.fail;
        var success = params.success;
        if (!componentCode) {
            showError("构件编码不能为空, 请检查入参是否正确.");
        }
        if (!windowCode) {
            showError("窗体编码不能为空, 请检查入参是否正确.");
        }
        if (!context) {
            showError("vue实例不能为空, 请检查入参数据是否正确.");
        }
        var eleId;
        if (!el) {
            showError("目标dom元素不存在，请检查入参数据是否正确.");
        } else if (typeof el == "string") {
            if (!document.getElementById(el)) {
                showError("目标dom元素不存在，请检查入参数据是否正确.");
            } else {
                eleId = el;
            }
        } else {
            if (el[0]) {
                el = el[0];
            }
            eleId = el.getAttribute("id");
            if (!eleId) {
                eleId = "rootContainer_" + new Date().getTime();
                el.setAttribute("id", eleId);
            }
        }
        var _inputParams = {
            variable: params.params
        };
        var parentScopeId = getScopeIdFromContext(context);
        var vjsList = ['vjs.framework.extension.ui.adapter.dependency', 'vjs.framework.extension.platform.services.view.relation', 'vjs.framework.extension.platform.services.view.widget.common.action', "vjs.framework.extension.platform.interface.scope", "vjs.framework.extension.platform.data.storage.schema.param"];
        var promise = _Utils2.default.loadVjs(vjsList);
        promise.then(function (sb) {
            var AppData = sb.getService("vjs.framework.extension.platform.data.storage.schema.param.ApplicationParam");
            if (AppData && typeof AppData.getWindowMapping == 'function') {
                /* 获取窗体映射信息 */
                var windowMappingInfo = AppData.getWindowMapping({
                    componentCode: componentCode,
                    windowCode: windowCode
                });
                /* 若窗体映射信息不为空的话，则表示是配置相应的映射信息，需替换 */
                if (windowMappingInfo != null) {
                    componentCode = windowMappingInfo.componentCode;
                    windowCode = windowMappingInfo.windowCode;
                }
            }
            var WindowContainer = sb.getService("vjs.framework.extension.platform.services.view.relation.WindowContainer");
            var windowRelation = sb.getService("vjs.framework.extension.platform.services.view.relation.WindowContainerManager");
            var widgetRenderer = sb.getService("vjs.framework.extension.platform.services.view.widget.common.action.WidgetRenderer");
            var ScopeManager = sb.getService("vjs.framework.extension.platform.interface.scope.ScopeManager");
            var newScopeId = ScopeManager.createWindowScope({
                "parentScopeId": parentScopeId,
                "componentCode": componentCode,
                "windowCode": windowCode
            });
            var windowScope = ScopeManager.getScope(newScopeId);
            //先沿用vui标签的打开方式，目前关闭方式只在浙交工使用，还没集成到主线版本
            windowScope.setOpenMode("vuiWindowContainer");
            var container = new WindowContainer({
                scopeId: newScopeId,
                componentCode: componentCode,
                windowCode: windowCode,
                windowType: "ComponentContainer"
            });
            windowRelation.put(container);
            var callback = function callback() {
                var renderCallback = function renderCallback(_winContent) {
                    var _winScope = ScopeManager.getWindowScope();
                    var tmpScript = _winContent[0];
                    var tmpContent = _winContent[1];
                    var isSimple = false;
                    var tmpId;
                    if (_winScope.getSeries() == "bootstrap_mobile") {
                        isSimple = true;
                        if (!_winScope.isSimpleDivWindow()) {
                            //简约div
                            var widgets = _winScope.getWidgets();
                            if (widgets) {
                                for (var widgetCode in widgets) {
                                    var type = widgets[widgetCode].type;
                                    if (type != "JGComponent" && type != "JGMDiv") {
                                        isSimple = false;
                                        break;
                                    }
                                }
                            } else {
                                isSimple = false;
                            }
                        }
                        if (isSimple) {
                            var tmpDiv = document.createElement("div");
                            var cDiv = document.createElement("div");
                            tmpDiv.appendChild(cDiv);
                            tmpId = "ap_" + new Date().getTime();
                            tmpDiv.setAttribute("id", tmpId);
                            document.getElementById(eleId).appendChild(tmpDiv);
                            _winScope.set("AssignRenderPlace", { //指定渲染位置，场景：渲染移动窗体到div需要自适应高
                                dom: cDiv
                            });
                        } else {
                            _winContent = $("<script type=\"text/javascript\">" + tmpScript.innerHTML + "</script>" + tmpContent.innerHTML);
                        }
                    }
                    widgetRenderer.executeComponentRenderAction("renderWindowToContainer", _winContent, eleId, false);
                    widgetRenderer.executeComponentRenderAction("setParentContainerInfo", windowCode, {
                        scopeId: parentScopeId,
                        containerCode: eleId
                    });
                    if (isSimple) {
                        document.getElementById(eleId).removeChild(tmpContent);
                    }
                    windowScope.on(ScopeManager.EVENTS.DESTROY, function (_eleId, _content, _tmpId) {
                        return function () {
                            var ctDom = document.getElementById(_eleId);
                            try {
                                if (_tmpId) {
                                    ctDom.removeChild(document.getElementById(_tmpId));
                                }
                                if (_content && _content.length > 0) {
                                    for (var i = 0, len = _content.length; i < len; i++) {
                                        ctDom.removeChild(_content[i]);
                                    }
                                }
                            } catch (e) {}
                            //document.getElementById(eleId).innerHTML = "";
                        };
                    }(eleId, _winContent, tmpId));
                    windowScope.set("RemoveModalFunc", function (_eleId, _content, _tmpId) {
                        return function () {
                            var ctDom = document.getElementById(_eleId);
                            try {
                                if (_tmpId) {
                                    ctDom.removeChild(document.getElementById(_tmpId));
                                }
                                if (_content && _content.length > 0) {
                                    for (var i = 0, len = _content.length; i < len; i++) {
                                        ctDom.removeChild(_content[i]);
                                    }
                                }
                            } catch (e) {}
                            //document.getElementById(eleId).innerHTML = "";
                        };
                    }(eleId, _winContent, tmpId));
                };
                var componentUtil = sb.getService("vjs.framework.extension.ui.adapter.init." + ScopeManager.getProperty("type") + ".web.util");
                componentUtil.renderComponentById(componentCode, windowCode, _inputParams || {}, {
                    "scopeId": newScopeId,
                    "rendered": renderCallback,
                    "inited": success,
                    "error": fail
                });
            };
            var dependency = sb.getService("vjs.framework.extension.ui.adapter.dependency");
            dependency.loadResources(componentCode, windowCode, sb, newScopeId, callback, fail);
        });
    },


    /**
     * 渲染窗体到首页页面
     * {
     *      type: "homeTab",//打开方式可选值：1、homeTab（首页，默认值），2、modal（模态）
     *      menuCode: "菜单编码",
     *      scope: "current",//可选值：1、current（当前，默认值），2、parent（父级），type为homeTab时有效，若后续支持top需要考虑首页怎么给当前窗体回复消息（三层嵌套，中间层非首页）
     *      error:  function(msg){}//打开失败回调
     * }
    */
    renderFromPortalMenu: function renderFromPortalMenu(params) {
        var type = params.type ? params.type : "homeTab",
            menuCode = params.menuCode,
            error = params.error,
            scope = params.scope ? params.scope : "current";
        var isError = false;
        var errorMsg = "";
        if (type != "homeTab" && type != "modal") {
            errorMsg = "打开方式仅支持首页或者模态弹窗，当前打开方式：" + msg;
        } else if (!menuCode) {
            errorMsg = "菜单编码不能为空";
        } else if (scope != "current" && scope != "parent") {
            errorMsg = "作用域错误，仅支持当前首页或者父级首页，当前作用域：" + scope;
        }
        if (isError) {
            _v3platform2.default.v3ExceptionAlert({
                "title": "业务异常",
                "msgHeader": "参数传递错误",
                "msg": errorMsg,
                "callback": error
            });
            return;
        }
        var vjsList;
        var loadSuccess;
        switch (scope) {
            case "parent":
                //父级打开
                vjsList = ['vjs.framework.extension.platform.interface.event'];
                loadSuccess = function loadSuccess(sb) {
                    var eventManager = sb.getService("vjs.framework.extension.platform.interface.event.EventManager");
                    //当前通信id
                    var iden = _v3platform2.default.genUUID();
                    var sendState = false; //发送状态
                    eventManager.onCrossDomainEvent({ //接受返回的首页消息
                        eventName: eventManager.CrossDomainEvents.CustomEvent,
                        eventInfo: {
                            condition: "type=='HomeTabMessageCallback'&&iden=='" + iden + "'"
                        },
                        handler: function handler(resParams) {
                            if (!resParams) {
                                return;
                            }
                            var responType = resParams.type;
                            switch (responType) {
                                case "parentReceived":
                                    sendState = true;
                                    break;
                            }
                        }
                    });
                    eventManager.fireCrossDomainEvent({ //给父级发送打开消息
                        eventName: eventManager.CrossDomainEvents.CustomEvent,
                        eventInfo: {
                            type: "OpenHomeTabMenuByCode"
                        },
                        params: {
                            iden: iden,
                            openParams: {
                                type: type,
                                menuCode: menuCode,
                                scope: "current"
                            }
                        }
                    });
                    setTimeout(function () {
                        if (!sendState) {
                            //3秒后还收不到返回消息，就提示报错
                            _v3platform2.default.v3ExceptionAlert({
                                "title": "系统异常",
                                "msgHeader": "无法打开窗体",
                                "msg": "请检查当前窗体属于首页的子窗体, scope:" + scope,
                                "callback": error
                            });
                            return;
                        }
                    }, 3000);
                };
                break;
            default:
                //当前
                switch (type) {
                    case "modal":
                        if (window.V3PlatformHomeTab && typeof window.V3PlatformHomeTab.getMenuData == "function") {
                            var menuItem = window.V3PlatformHomeTab.getMenuData(menuCode);
                            if (!menuItem) {
                                _v3platform2.default.v3ExceptionAlert({
                                    "title": "业务异常",
                                    "msgHeader": "参数传递错误",
                                    "msg": "菜单编码错误，无法获取对应菜单数据，菜单编码：" + menuCode,
                                    "callback": error
                                });
                                return;
                            }
                            var title = menuItem.menuItemName;
                            if (menuItem.menuItemType == "url") {
                                vjsList = ["vjs.framework.extension.platform.services.view.modal"];
                                if (!menuItem.url) {
                                    _v3platform2.default.v3Log("warn", "菜单编码无映射链接，已忽略打开，菜单编码：" + menuCode);
                                }
                                loadSuccess = function loadSuccess(sb) {
                                    var modalUtils = sb.getService("vjs.framework.extension.platform.services.view.modal.CreateModalByUrl");
                                    modalUtils.create({
                                        "url": menuItem.url,
                                        "title": title
                                    });
                                };
                            } else if (menuItem.menuItemType == "win") {
                                var componentCode = menuItem.openCompCode;
                                var windowCode = menuItem.openWinCode;
                                if (!componentCode || !windowCode) {
                                    /*v3platform.v3ExceptionAlert({
                                        "title" : "系统异常",
                                        "msgHeader" : "无法打开窗体",
                                        "msg" : "菜单编码无映射窗体，菜单编码：" + menuCode,
                                        "callback":error
                                    });*/
                                    _v3platform2.default.v3Log("warn", "菜单编码无映射窗体，已忽略打开，菜单编码：" + menuCode);
                                    return;
                                }
                                vjsList = ["vjs.framework.extension.platform.services.browser"];
                                loadSuccess = function loadSuccess(sb) {
                                    var browser = sb.getService("vjs.framework.extension.platform.services.browser.Browser");
                                    var windowInputParams = {
                                        "variable": {
                                            "formulaOpenMode": "dialog"
                                        }
                                    };
                                    browser.showModalModule({
                                        "componentCode": componentCode,
                                        "windowCode": windowCode,
                                        "title": title,
                                        "inputParam": windowInputParams
                                    });
                                };
                            }
                        } else {
                            _v3platform2.default.v3ExceptionAlert({
                                "title": "系统异常",
                                "msgHeader": "无法打开窗体",
                                "msg": "未获取到首页提供的接口：getMenuData",
                                "callback": error
                            });
                            return;
                        }
                        break;
                    default:
                        if (window.V3PlatformHomeTab && typeof window.V3PlatformHomeTab.openMenu == "function") {
                            window.V3PlatformHomeTab.openMenu({
                                menuCode: menuCode,
                                error: error
                            });
                        } else {
                            _v3platform2.default.v3ExceptionAlert({
                                "title": "系统异常",
                                "msgHeader": "无法打开窗体",
                                "msg": "未获取到首页提供的接口：openMenu",
                                "callback": error
                            });
                        }
                        return;
                }
        }
        var promise = _Utils2.default.loadVjs(vjsList);
        promise.then(loadSuccess).catch(function (msg) {
            _v3platform2.default.v3ExceptionAlert({
                "title": "系统异常",
                "msgHeader": "无法打开窗体",
                "msg": "加载相关的vjs服务失败：" + msg,
                "callback": error
            });
        });
    }

};

/***/ }),

/***/ "fTHo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Utils = __webpack_require__("ATBs");

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    /**
     *  调用后台webapi
     * @param {Object} params 参数信息
     * {
     *  apiCode         :   api编号，
     *  componentCode   :   构件编号,
     *  params          ：  参数信息，
     *  success         :   成功回调，
     *  fail            :   失败回调
     * }
     */
    exec: function exec(params) {
        if (!_Utils2.default.assertNotNull(params, 'apiCode') || !_Utils2.default.assertNotNull(params, 'componentCode')) {
            var msg = '调用后台webapi时，请传递apiCode、componentCode参数！';
            if (params.fail) {
                params.fail({
                    type: "UnExpectedException",
                    msg: msg
                });
            } else {
                throw Error(msg);
            }
        }
        var promise = _Utils2.default.loadVjs("vjs.framework.extension.platform.services.operation.remote.ruleset");
        promise.then(function (sb) {
            var invoker = sb.getService("vjs.framework.extension.platform.services.operation.remote.RemoteMethodAccessor");
            invoker.invokeV3Webapi({
                componentCode: params.componentCode,
                apiCode: params.apiCode,
                param: params.params,
                afterResponse: params.success,
                error: params.fail
            });
        }).catch(function (err) {
            params.fail && params.fail(err);
        });
    }
};

/***/ }),

/***/ "g9f8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Utils = __webpack_require__("ATBs");

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var invokeVFunc = function invokeVFunc(funcName, _this) {
	var root = _this.$root;
	if (root && root._$v3platform) {
		var v3platform = root._$v3platform();
		var func = v3platform.datasource[funcName];
		if (func) {
			var args = Array.prototype.slice.call(arguments, 2);
			return func.apply(root, args);
		}
	}
};

/**
 * 注册数据源更新事件
 * @param {Object} params
 * {
 * 	vueObj : VueCompoent,//vue对象，
//  *  handler : function(){}//处理
 * }
 * @returns true表示注册事件成功，false表示注册失败
 */
var registerDsUpdateEvent = function registerDsUpdateEvent(params) {
	var vue = params.vueObj;
	if (typeof vue.$root._$registerDsEvent == 'function') {
		vue.$root._$registerDsEvent(function (_this) {
			return function () {
				var _$attrs = _this.$attrs;
				if (_$attrs && _$attrs["___ds___"] && _$attrs["___field___"]) {
					var _dsName = _$attrs["___ds___"];
					var _field = _$attrs["___field___"];
					if (_field.indexOf(",") != -1) {
						_field = _field.split(",");
					} else {
						_field = [_$attrs["___field___"]];
					}
					var _ds = _this.$root._$getDatasource(_dsName);
					if (_ds != null) {
						_ds.on({
							"eventName": _ds.Events.UPDATE,
							"handler": function handler(params) {
								/* 是否改变 */
								var isChange = false;
								/* 旧值 */
								var oldVal = null;
								/* 新值 */
								var newVal = null;
								/* 新数据 */
								var datas = params.resultSet.datas;
								if (datas && datas.length > 0) {
									for (var i = 0, len = datas.length; i < len; i++) {
										var data = datas[i];
										var changeData = data.getChangedData();
										for (var j = 0, l = _field.length; j < l; j++) {
											if (changeData.hasOwnProperty(_field[j])) {
												newVal = changeData[_field[j]];
												isChange = true;
											}
										}
									}
								}
								datas = params.oldResultSet.datas;
								if (datas && datas.length > 0) {
									for (var i = 0, len = datas.length; i < len; i++) {
										var data = datas[i];
										for (var j = 0, l = _field.length; j < l; j++) {
											oldVal = data[_field[j]];
										}
									}
								}
								if (isChange) _this.$nextTick(function () {
									_this.$emit("on-change", newVal, oldVal);
								});
							}
						});
					}
				}
			};
		}(vue));
		return true;
	}
	return false;
};

/**
 * 获取资源图片路径
 */
var getSrcPathFromRes = function getSrcPathFromRes(node, value) {
	if (!node.$root._getComponentCode) {
		return value;
	}
	var componentCode = node.$root._getComponentCode();
	var path = "itop/resources/" + componentCode + "_" + value;
	var val = window.GlobalVariables ? GlobalVariables.getServerUrl() + "/" + path : path;
	return val;
};
/**
* 获取附件id路径
*/
var getSrcPathFromId2url = function getSrcPathFromId2url(value) {
	if (value == undefined || value == null || !value || value == "") {
		return;
	}
	var url = "module-operation!executeOperation?operation=FileDown&token=%7B%22data%22%3A%7B%22dataId%22%3A%22" + value + "%22%2C%22ImageObj%22%3A%22" + value + "%22%7D%7D";
	var val = window.GlobalVariables ? GlobalVariables.getServerUrl() + "/" + url : url;
	return val;
};

exports.default = {
	/**
  * 同步当前行到数据源
  */
	synCurrentRecordToDs: function synCurrentRecordToDs(_this, entityCode, newData, oldData) {
		return invokeVFunc('synCurrentRecordToDs', _this, entityCode, newData, oldData);
	},
	/**
  * 此方法已废弃
  * 同步当前行到数据源
  */
	synCurrentIdToDs: function synCurrentIdToDs(_this, entityCode, newData, oldData) {
		return invokeVFunc('synCurrentIdToDs', _this, entityCode, newData, oldData);
	},
	/**
  * 同步选中行到数据源
  */
	synSelectRecordToDs: function synSelectRecordToDs(_this, entityCode, data, isSel) {
		return invokeVFunc('synSelectRecordToDs', _this, entityCode, data, isSel);
	},
	registerCurrentHandler: function registerCurrentHandler(_this, handler) {
		return invokeVFunc('registerCurrentHandler', _this, handler);
	},
	registerSelectHandler: function registerSelectHandler(_this, handler) {
		return invokeVFunc('registerSelectHandler', _this, handler);
	},
	markDsMultipleSelect: function markDsMultipleSelect(_this, entityCode) {
		return invokeVFunc('markDsMultipleSelect', _this, entityCode);
	},
	/* 获取vui版本，2.0为新版vui */
	getVuiVersion: function getVuiVersion(nowVue) {
		if (nowVue && nowVue.$root) {
			return nowVue.$root.vui_version;
		}
		return null;
	},
	getCurrentRecord: function getCurrentRecord(_this, entityCode) {
		return invokeVFunc('getCurrentRecord', _this, entityCode);
	},
	getSelectedRecords: function getSelectedRecords(_this, entityCode) {
		return invokeVFunc('getSelectedRecords', _this, entityCode);
	},
	isSelected: function isSelected(_this, entityCode, record) {
		return invokeVFunc('isSelectedRecord', _this, entityCode, record);
	},
	isCurrent: function isCurrent(_this, entityCode, record) {
		return invokeVFunc('isCurrentRecord', _this, entityCode, record);
	},
	markMultipleDs: function markMultipleDs(_this, entityCode) {
		return invokeVFunc('setDsMultiSelect', _this, entityCode);
	},
	registerDsUpdateEvent: registerDsUpdateEvent,
	getSrcPathFromRes: getSrcPathFromRes,
	getSrcPathFromId2url: getSrcPathFromId2url,
	genUUID: function genUUID() {
		function S4() {
			return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
		}
		return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
	},
	isRunInV3Service: function isRunInV3Service(params) {
		if (!window.VMetrix || !window.VMetrix.loadBundles) {
			return false;
		}
		// throw new Error("未运行在V3服务内，无法执行操作.");
		return true;
	},
	/**
  * 加载vjs
  * 
 */
	/**
  * 加载vjs
  * @params
  * {
  * 	'vjs':[],//vjs列表
  * 	'success':function(){},//'成功回调'
  *  'error':function(){}//'错误回调'
  * }
  * */
	loadVjs: function loadVjs(params) {
		var _this2 = this;

		var vjs = params.vjs;
		var success = params.success;
		var error = params.error;
		if (vjs && vjs instanceof Array && vjs.length > 0) {
			var promise = _Utils2.default.loadVjs(vjs);
			promise.then(function (sandbox) {
				if (typeof success == "function") {
					success.apply(_this2, [sandbox]);
				}
			}).catch(function (err) {
				if (typeof error == "function") {
					error.apply(_this2, [err]);
				}
			});
		}
	},
	v3Log: function v3Log(type, msg) {
		if (window && window.console) {
			if (!type || !window.console[type]) {
				type = "log";
			}
			window.console[type](msg);
		}
	},
	/**
  * 创建异常信息提示框
  * @params
  * {
  * 	'title':'提示框标题',
  * 	'msgHeader':'错误信息标题',
  *  'msg':'错误信息',
  *  'detail':'详情信息',
  *  'callback':'提示框关闭后回调'
  * }
  * */
	v3ExceptionAlert: function v3ExceptionAlert(params) {
		this.loadVjs({
			"vjs": ["vjs.framework.extension.platform.interface.alerter"],
			"success": function success(sb) {
				var frontendAlerter = sb.getService("vjs.framework.extension.platform.interface.alerter.FrontEndAlerter");
				if (frontendAlerter) {
					frontendAlerter.error(params);
				}
			},
			'error': function error(msg) {
				this.v3Log("忽略使用平台异常弹框服务：" + msg, "warn");
				alert(params.msg);
				if (typeof params.callback == "function") {
					params.callback();
				}
			}
		});
	}
};

/***/ }),

/***/ "vn7Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _v3platform = __webpack_require__("g9f8");

var _v3platform2 = _interopRequireDefault(_v3platform);

var _constants = __webpack_require__("RYcG");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columnHandlerKey = '___$ColumnChangeHandler___';
/**
 * {
	prop:{
		//属性名称
		name:'dataSource',
		//是否必填
		required:true/false,
		//默认值
		default:[],
		//校验函数
		validator:function
	},
	event:{
		//数据加载事件
		load:false/true/{
			name:'on-load'
		},
		//数据变化事件
		change:false/true/{
			name:'on-change',
			handler:
		},
		//记录切换事件
		currentChange:false/true/{
			name:'on-current-change'
		},
		//记录选择变更事件
		selectionChange:false/true/{
			name:'on-selection-change'
		}
	}
}
{
	props:{
		dataSource:{
			type:Array,
			v3PropType:'datasource'
			required:options.required,
			default:[],
			validator:options.validator
		}
	},
	created:function(){
		1、注册数据源加载事件LOAD
		2、注册数据源记录切换事件CURRENT
		3、注册数据源数据变化事件UPDATE
		4、注册记录选择变更事件SELECT
	},
	methods:{
		1、设置当前行
		2、设置选中记录
		....
	}
}
 * 
*/
function DatasourceMixin(params) {
	var mixin = getMixin(params, "datasource");
	return mixin;
}

/**
 * 
 * @param {*} params 
 */
var RecordMixin = function RecordMixin(params) {
	var mixin = getMixin(params, "record");
	return mixin;
};
/**
 * 
 * @param {*} params 
 */
var CellMixin = function CellMixin(params) {
	if (!params) {
		params = {
			prop: {
				name: "value"
			}
		};
	} else if (!params.prop) {
		params.prop = {
			name: "value"
		};
	} else {
		params.prop.name = "value";
	}

	var mixin = getMixin(params, "cell");
	mixin.watch = {
		value: function value(newVal, oldVal) {
			this.$emit('input', newVal);
		}
	};
	return mixin;
};
var getMixin = function getMixin(params, type) {
	var result = {};
	if (check(params, type)) {
		// 合并默认参数
		params = mergeDefaultParams(params, type);
		var props = getProps(params.prop, type);
		//获取create钩子函数
		var createFunc = getCreateFunc(params, type);
		var methods = getMethods(params, type);
		result = {
			props: props,
			// beforeCreate : createFunc,
			created: createFunc,
			data: function data() {
				return {
					V3_PLATFORM_ENTITY_DATAS_INFO_IDEN: {} //本地实体数据处理信息,非数据源，不可存数组值，因为其他接口无数据源名称，需遍历数组值
				};
			},
			methods: methods
		};
	}
	return result;
};
function mergeDefaultParams(params, type) {
	var defaultParams = getDefaultParams(type);
	for (var propKey in params.prop) {
		defaultParams.prop[propKey] = params.prop[propKey];
	}
	for (var eventKey in params.event) {
		defaultParams.event[eventKey] = params.event[eventKey];
	}
	return defaultParams;
}
function getDefaultParams(type) {
	var defaultParams = {
		datasource: {
			prop: {
				required: true,
				default: []
			},
			event: {
				"load": true,
				"change": true,
				"currentChange": true,
				"selectionChange": true
			}
		},
		record: {
			prop: {
				required: true,
				default: {}
			},
			event: {
				"load": true,
				"change": true
			}
		},
		cell: {
			prop: {
				required: true,
				default: {}
			},
			event: {
				"load": true,
				"change": true
			}
		}
	};
	return defaultParams[type];
}
function getMethods(params, type) {
	var methodsList = {
		'datasource': ['isCurrent', 'isSelected', 'markCurrent', 'markSelected', 'markUnSelect', 'getDatasourceName', 'getCurrentRecord', 'getSelectedRecords', 'v3PlatformFireEvent', 'markDatasourceMultipleSelect', 'registerColumnChangeHandler']
	};
	var propName = params.prop.name;
	var methods = {};
	var appointMethods = methodsList[type];
	if (appointMethods) {
		for (var i = 0, l = appointMethods.length; i < l; i++) {
			var key = appointMethods[i];
			var method = getMethod(key, propName);
			methods[key] = method;
		}
	}
	return methods;
}
function getMethod(key, propName) {
	var setSelectRecords = function setSelectRecords(_this, records, isSelected) {
		if (records instanceof Array) {
			var recordsLength = records.length;
			if (recordsLength > 0) {
				if (isRunInV3Service(_this)) {
					var dsName = null;
					if (records[0]._metadata_) {
						dsName = records[0]._metadata_.dsName;
					} else {
						throw new Error('无法获取实体编码');
					}
					for (var i = 0; i < recordsLength; i++) {
						var record = records[i];
						if (record) {
							_v3platform2.default.synSelectRecordToDs(_this, dsName, record, isSelected);
						} else {
							throw new Error('行记录不存在，无法设置为选中状态');
						}
					}
				} else {
					var entityInfo = _this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[propName];
					var selectedRecords = entityInfo.selectedRecords;
					if (isSelected === true) {
						var record = records[0];
						if (_this.isMultipleSel === true) {
							var hasChange = false;
							for (var i = 0, len = records.length; i < len; i++) {
								var record = records[i];
								if (selectedRecords.indexOf(record) == -1) {
									selectedRecords.push(record);
									hasChange = true;
								}
							}
							if (hasChange) {
								//触发选中行改变
								_this.v3PlatformFireEvent(_this, entityInfo.selectionChange, [entityInfo.selectedRecords]);
							}
						} else {
							if (records.length > 1) {
								_v3platform2.default.v3Log("warn", "非多选数据源，不支持设置多个选中，已选第一条作为选中记录");
							}
							if (record != entityInfo.currentRecord) {
								entityInfo.currentRecord = record;
								entityInfo.selectedRecords = [record];
								//触发当前行改变事件
								_this.v3PlatformFireEvent(_this, entityInfo.currentChange, [entityInfo.currentRecord]);
								//触发选中行改变
								_this.v3PlatformFireEvent(_this, entityInfo.selectionChange, [entityInfo.selectedRecords]);
							}
						}
					} else {
						if (_this.isMultipleSel === true) {
							var hasChange = false;
							for (var i = 0, len = records.length; i < len; i++) {
								var record = records[i];
								var index = selectedRecords.indexOf(record);
								if (index != -1) {
									hasChange = true;
									selectedRecords.splice(index, 1);
								}
							}
							if (hasChange) {
								//触发选中行改变
								_this.v3PlatformFireEvent(_this, entityInfo.selectionChange, [entityInfo.selectedRecords]);
							}
						} else {
							_v3platform2.default.v3Log("error", "非多选数据源, 不支持取消选中");
						}
					}
				}
			}
		} else {
			throw new Error('标记选中/不选中的数据必须为数组类型，只标记一行数据请用"[]"将数据包装成数组。');
		}
	};
	var notFoundDsName = function notFoundDsName() {
		throw new Error('无法获取实体编码');
	};
	/**
  * 获取实体编码
  * @param {*} _this 
  * @param {*} propName 
  */
	var getDsName = function getDsName(_this) {
		if (_this.$options.propsData[propName]._metadata_) {
			return _this.$options.propsData[propName]._metadata_.dsName;
		} else if (_this[propName]._metadata_) {
			return _this[propName]._metadata_.dsName;
		} else if (_this[propName] && _this[propName][0] && _this[propName][0]._metadata_) {
			return _this[propName][0]._metadata_.dsName;
		} else {
			return null;
		}
	};
	var isRunInV3Service = function isRunInV3Service(_this) {
		return _v3platform2.default.isRunInV3Service();
	};
	var defaultMethods = {
		'registerColumnChangeHandler': function registerColumnChangeHandler(field, handler) {
			var _this = this;
			if (_this[columnHandlerKey]) {
				_this[columnHandlerKey][field] = handler;
			} else {
				_this[columnHandlerKey] = {};
				_this[columnHandlerKey][field] = handler;
			}
		},
		'getDatasourceName': function getDatasourceName() {
			var _this = this;
			if (isRunInV3Service(this)) {
				return getDsName(_this);
			} else {
				if (window.console) {
					window.console.warn("本地数据暂不支持获取数据源名称");
				}
				return null;
			}
		},
		'getCurrentRecord': function getCurrentRecord() {
			var _this = this;
			if (isRunInV3Service(this)) {
				return _v3platform2.default.getCurrentRecord(_this, getDsName(_this));
			} else {
				var entityInfo = _this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[propName];
				return entityInfo.currentRecord;
			}
		},
		'getSelectedRecords': function getSelectedRecords() {
			var _this = this;
			if (isRunInV3Service(this)) {
				return _v3platform2.default.getSelectedRecords(_this, getDsName(_this));
			} else {
				var entityInfo = _this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[propName];
				return entityInfo.selectedRecords;
			}
			return [];
		},
		'markDatasourceMultipleSelect': function markDatasourceMultipleSelect() {
			var _this = this;
			if (isRunInV3Service(_this)) {
				//V平台服务
				var dsName = getDsName(_this);
				_v3platform2.default.markMultipleDs(_this, dsName);
			} else {
				//本地数据
				var entityInfo = this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[propName];
				entityInfo.isMultipleSel = true;
			}
		},
		'isCurrent': function isCurrent(data) {
			var _this = this;
			if (typeof data === 'string') {
				if (!isRunInV3Service(this)) {
					if (window.console) {
						window.console.warn("本地数据不支持根据id判断是否当前行");
					}
					return false;
				}
				var dsName = getDsName(_this);
				if (dsName) {
					var currentRecord = _v3platform2.default.getCurrentRecord(_this, dsName);
					var cid = currentRecord.id;
					if (cid) {
						return cid === data;
					} else {
						throw new Error("无法读取当前行记录的id属性，无法校验");
					}
				} else {
					notFoundDsName();
				}
			} else if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
				if (isRunInV3Service(this)) {
					var dsName = data._metadata_.dsName;
					if (dsName) {
						return _v3platform2.default.isCurrent(_this, dsName, data);
					} else {
						notFoundDsName();
					}
				} else {
					var entityInfo = this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[propName];
					return data == entityInfo.currentRecord;
				}
			} else {
				throw new Error("不支持处理该类型数据，传入数据必须是行记录的id(string)或行记录(object)");
			}
		},
		'isSelected': function isSelected(data) {
			var _this = this;
			if (typeof data === 'string') {
				if (!isRunInV3Service(this)) {
					if (window.console) {
						window.console.warn("本地数据不支持根据id判断是否选中行");
					}
					return false;
				}
				var dsName = getDsName(_this);
				if (dsName) {
					var selectedRecords = _v3platform2.default.getSelectedRecords(_this, dsName);
					if (selectedRecords) {
						for (var i = 0, l = selectedRecords.length; i < l; i++) {
							var sid = selectedRecords[i].id;
							if (sid === data) {
								return true;
							}
						}
						return false;
					} else {
						throw new Error("无法获取选中行记录");
					}
				} else {
					notFoundDsName();
				}
			} else if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
				if (isRunInV3Service(this)) {
					var dsName = data._metadata_.dsName;
					if (dsName) {
						return _v3platform2.default.isSelected(_this, dsName, data);
					} else {
						notFoundDsName();
					}
				} else {
					var entityInfo = this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[propName];
					var selectRecords = entityInfo.selectedRecords;
					if (selectRecords.indexOf(data) != -1) {
						return true;
					}
				}
			} else {
				throw new Error("不支持处理该类型数据，传入数据必须是行记录的id(string)或行记录(object)");
			}
		},
		'markCurrent': function markCurrent(data) {
			var _this = this;
			var dsName = getDsName(_this);
			if (typeof data === 'string') {
				if (!isRunInV3Service(this)) {
					if (window.console) {
						window.console.warn("本地数据不支持使用id设置选中行");
					}
					return false;
				}
				var ds = _this[propName];
				if (ds) {
					var record = null;
					for (var i = 0, l = ds.length; i < l; i++) {
						var item = ds[i];
						if (item.id === data) {
							record = item;
							break;
						}
					}
					if (record) {
						_v3platform2.default.synCurrentRecordToDs(_this, dsName, record);
					} else {
						throw new Error("无法根据ID获取行记录");
					}
				} else {
					throw new Error("无法获取实体");
				}
			} else if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
				if (isRunInV3Service(this)) {
					if (null == dsName) {
						if (data._metadata_) {
							dsName = data._metadata_.dsName;
						}
					}
					_v3platform2.default.synCurrentRecordToDs(_this, dsName, data);
				} else {
					var entityInfo = this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[propName];
					entityInfo.currentRecord = data;
					//触发当前行改变事件
					this.v3PlatformFireEvent(this, entityInfo.currentChange, [entityInfo.currentRecord]);
					if (entityInfo.isMultipleSel === false) {
						//非多选，更新选中行
						entityInfo.selectedRecords = [data];
						//触发选中行改变
						this.v3PlatformFireEvent(this, entityInfo.selectedChange, [entityInfo.selectedRecords]);
					}
				}
			} else {
				throw new Error("不支持处理该类型数据，传入数据必须是行记录的id(string)或行记录(object)");
			}
		},
		'markSelected': function markSelected(records) {
			var _this = this;
			setSelectRecords(_this, records, true);
		},
		'markUnSelect': function markUnSelect(records) {
			var _this = this;
			setSelectRecords(_this, records, false);
		},
		'v3PlatformFireEvent': function v3PlatformFireEvent(instance, events, params) {
			for (var i = 0, len = events.length; i < len; i++) {
				var event = events[i];
				if (typeof event == "function") {
					event.apply(instance, params);
				}
			}
		}
	};
	return defaultMethods[key];
}

/**
 * 监听字段数据
 * @params {Object} instance vue实例
 * @params {String} dsName 实体名称
 * @params {String} iden 数据表示
 * 
*/
function watchFieldData(instance, dsName, iden) {
	var destroy = instance.$watch("V3_PLATFORM_ENTITY_DATAS_INFO_IDEN." + dsName + "." + "datas" + "." + iden, function (_this, name) {
		return function (record) {
			debugger;
			var entityInfos = _this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[name];
			var changeEvents = entityInfos.change;
			if (changeEvents && changeEvents.length > 0) {
				for (var i = 0, len = changeEvents.length; i < len; i++) {
					var event = changeEvents[i];
					if (typeof event == "function") {
						event.apply(_this, [record]);
					}
				}
			}
		};
	}(instance, dsName), {
		deep: true,
		sync: true
	});
	//保存销毁watch的函数
	instance.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[dsName].destroys[iden] = destroy;
}

/**
 * 处理本地数据的实体事件
 * @params {Array} events 事件列表
 * @params {String} dsName 实体名称
 * @params {Object} instance vue实例
 * 
*/
function handlerLocalEntityCell(events, dsName, instance) {
	var entityInfos = instance.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN;
	if (!entityInfos.hasOwnProperty(dsName)) {
		var dataIden = _v3platform2.default.genUUID();
		var entityInfo = {
			datas: {}, //数据索引映射 索引 --> 数据
			destroys: {}, //销毁数据监听函数
			load: [],
			change: []
		};
		entityInfos[dsName] = entityInfo;
		var datas = entityInfo.datas;
		//初始数据
		var nowRecords = instance[dsName];
		//1、处理实体事件
		if (events) {
			for (var i = 0, len = events.length; i < len; i++) {
				var event = events[i];
				var type = event.eventType;
				if (entityInfo.hasOwnProperty(type)) {
					entityInfo[type].push(event.handler);
				}
			}
		}
		//2、处理实体初始的数据，获得初始数据并监听
		if (nowRecords) {
			//触发加载事件
			fireEvent(instance, entityInfo.load, [nowRecords]);
		}
		instance.$watch(dsName, function (newVal, oldVal) {
			var changeEvents = instance.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[dsName].change;
			if (changeEvents && changeEvents.length > 0) {
				for (var i = 0, len = changeEvents.length; i < len; i++) {
					var event = changeEvents[i];
					if (typeof event == "function") {
						event.apply(instance, [newVal, oldVal]);
					}
				}
			}
		});
	}
}

/**
 * 处理本地数据的实体事件
 * @params {Array} events 事件列表
 * @params {String} dsName 实体名称
 * @params {Object} instance vue实例
 * 
*/
function handlerLocalEntityRecord(events, dsName, instance) {
	var entityInfos = instance.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN;
	if (!entityInfos.hasOwnProperty(dsName)) {
		var dataIden = _v3platform2.default.genUUID();
		var entityInfo = {
			datas: {}, //数据索引映射 索引 --> 数据
			destroys: {}, //销毁数据监听函数
			load: [],
			change: []
		};
		entityInfos[dsName] = entityInfo;
		var datas = entityInfo.datas;
		//初始数据
		var nowRecords = instance[dsName];
		//1、处理实体事件
		if (events) {
			for (var i = 0, len = events.length; i < len; i++) {
				var event = events[i];
				var type = event.eventType;
				if (entityInfo.hasOwnProperty(type)) {
					entityInfo[type].push(event.handler);
				}
			}
		}
		//2、处理实体初始的数据，获得初始数据并监听
		if (nowRecords) {
			//索引标识
			var iden = _v3platform2.default.genUUID();
			datas[iden] = nowRecords;
			//监听字段数据
			watchFieldData(instance, dsName, iden);
			//触发加载事件
			fireEvent(instance, entityInfo.load, nowRecords);
		}
	}
}

/**
 * 处理本地数据的实体事件
 * @params {Array} events 事件列表
 * @params {String} dsName 实体名称
 * @params {Object} instance vue实例
 * 
*/
function handlerLocalEntity(events, dsName, instance) {
	var entityInfos = instance.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN;
	if (!entityInfos.hasOwnProperty(dsName)) {
		var dataIden = _v3platform2.default.genUUID();
		var entityInfo = {
			datas: {}, //数据索引映射 索引 --> 数据
			destroys: {}, //销毁数据监听函数
			currentRecord: null, //
			currentRecordDestory: null,
			selectedRecords: [],
			selectedRecordsDestory: null,
			isMultipleSel: false,
			load: [],
			change: [],
			currentChange: [],
			selectionChange: []
		};
		entityInfos[dsName] = entityInfo;
		var datas = entityInfo.datas;
		//初始数据
		var nowRecords = instance[dsName];
		//1、处理实体事件
		if (events) {
			for (var i = 0, len = events.length; i < len; i++) {
				var event = events[i];
				var type = event.eventType;
				if (entityInfo.hasOwnProperty(type)) {
					entityInfo[type].push(event.handler);
				}
			}
		}
		//2、处理实体初始的数据，获得初始数据并监听
		if (nowRecords && nowRecords.length > 0) {
			entityInfo.currentRecord = nowRecords[0];
			//后续需处理默认是多选的情况，因为默认多选是不需要设置选中的
			entityInfo.selectedRecords.push(nowRecords[0]);
			for (var i = 0; i < nowRecords.length; i++) {
				//索引标识
				var iden = _v3platform2.default.genUUID();
				var record = nowRecords[i];
				datas[iden] = record;
				//监听字段数据
				watchFieldData(instance, dsName, iden);
			}
			//触发加载事件
			fireEvent(instance, entityInfo.load, nowRecords);
		}

		//3、监听实体数据变化
		instance.$watch(dsName, function (newRecord) {
			debugger;
			try {
				//旧数据信息
				var oldRecordInfos = this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[dsName];
				//旧数据
				var oldRecords = []; //数据
				var data_mappings = {}; //数据 --> 索引
				var oldDatas = oldRecordInfos.datas; //索引 --> 数据
				for (var key in oldDatas) {
					oldRecords.push(oldDatas[key]);
				}
				var insertRecords = [];
				var deleteRecords = [];
				var selectedRecords = oldRecordInfos.selectedRecords;
				//1、筛选出新增的数据
				if (newRecord && newRecord.length > 0) {
					for (var i = 0, len = newRecord.length; i < len; i++) {
						var record = newRecord[i];
						if (oldRecords.indexOf(record) == -1) {
							//新增
							insertRecords.push(record);
						}
					}
				}
				//2、筛选出删除的数据
				for (var i = 0, len = oldRecords.length; i < len; i++) {
					var record = oldRecords[i];
					if (newRecord.indexOf(record) == -1) {
						//删除
						deleteRecords.push(record);
					}
				}
				var updateCurrent = false;
				var selectedChange = false;
				//3、处理删除
				if (deleteRecords.length > 0) {
					var destroys = oldRecordInfos.destroys;
					for (var i = 0, len = deleteRecords.length; i < len; i++) {
						var record = deleteRecords[i];
						if (oldRecordInfos.currentRecord === record) {
							//删除了当前行
							updateCurrent = true;
						}
						var selIndex = selectedRecords.indexOf(record);
						if (selIndex != -1) {
							//删除了选中
							selectedRecords.splice(selIndex, 1);
							selectedChange = true;
						}
						for (var iden in oldDatas) {
							if (record === oldDatas[iden]) {
								var destroy = destroys[iden];
								try {
									//销毁记录监听
									if (typeof destroy == "function") {
										destroy();
									}
									delete oldDatas[iden];
									break;
								} catch (e) {}
							}
						}
					}
				}
				//4、处理新增
				if (insertRecords.length > 0) {
					updateCurrent = true;
					for (var i = 0, len = insertRecords.length; i < len; i++) {
						var record = insertRecords[i];
						var iden = _v3platform2.default.genUUID();
						oldDatas[iden] = record;
						//监听字段数据
						watchFieldData(instance, dsName, iden);
					}
				}

				//5、触发事件 当前行/选中行事件 没有记录则都不触发
				if (newRecord.length > 0) {
					//处理当前行、选中行
					var currentRecord = newRecord[newRecord.length - 1];
					oldRecordInfos.currentRecord = currentRecord;
					if (oldRecordInfos.isMultipleSel === false) {
						if (oldRecordInfos.selectedRecords.indexOf(currentRecord) == -1) {
							selectedChange = true;
							oldRecordInfos.selectedRecords.push(currentRecord);
						}
					}
					if (insertRecords.length > 0) {
						if (insertRecords.length > 1 || deleteRecords.length > 0) {
							//属于直接赋值一个新数组
							//触发加载事件
							fireEvent(instance, oldRecordInfos.load, nowRecords);
						} else if (insertRecords.length == 1) {
							//当期行事件
							fireEvent(this, oldRecordInfos.currentChange, [oldRecordInfos.currentRecord]);
							if (selectedChange) {
								//选中行事件
								fireEvent(this, oldRecordInfos.selectionChange, [oldRecordInfos.selectedRecords]);
							}
						}
					} else if (deleteRecords.length > 0) {
						//当期行事件
						fireEvent(this, oldRecordInfos.currentChange, [oldRecordInfos.currentRecord]);
						//选中行事件
						fireEvent(this, oldRecordInfos.selectionChange, [oldRecordInfos.selectedRecords]);
					}
				}
			} catch (e) {
				if (window && window.console) {
					window.console.error("处理数据错误." + e);
				}
			} finally {
				this._$V3PlatformDataHandlerIden = false;
			}
		}, {
			deep: false,
			sync: true
		});
	}
}

/**
 * 触发事件
 * @param {Object} instance 执行实例
 * @param {Array} events 事件列表
 * @param {Object} params 事件参数
 */
function fireEvent(instance, events, params) {
	for (var i = 0, len = events.length; i < len; i++) {
		var event = events[i];
		if (typeof event == "function") {
			event.apply(instance, params);
		}
	}
}
function getCreateFunc(params, type) {
	//获取事件
	var _registerDsEvent = registerDsEvent;
	return function () {
		var _this = this;
		var events = getEventInfos(params, _this, type);
		if (!_v3platform2.default.isRunInV3Service()) {
			//非v3服务添加数据源监听
			var dsName = params.prop.name;
			switch (type) {
				case "record":
					handlerLocalEntityRecord(events, dsName, _this);
					break;
				case "cell":
					handlerLocalEntityCell(events, dsName, _this);
					break;
				default:
					//本地数据的处理方法
					handlerLocalEntity(events, dsName, _this);
					break;
			}
		} else {
			events.forEach(function (event, index) {
				var _event = event;
				event.vueObj = _this;
				_registerDsEvent(event);
			});
		}
	};
}
function getEventInfos(params, _this, type) {
	var eventInfo = params.event;
	var dsName = params.prop.name;
	var events = [];
	if (eventInfo) {
		for (var key in eventInfo) {
			if (eventInfo.hasOwnProperty(key)) {
				var info = getEventInfo(eventInfo[key], key, _this, type);
				if (info) {
					info.controlType = type;
					info.dsName = dsName;
					events.push(info);
				}
			}
		}
	}

	/**
  * datasource的mixins默认注册列的值变化事件
  * 避免自定义change的handler时将列的值变化事件覆盖
  */
	if (type === 'datasource') {
		var columnChangeEvent = {
			eventType: 'change',
			controlType: type,
			dsName: dsName,
			name: 'on-cell-change',
			handler: function handler(changeDatas, allDatas) {
				columnValueChange(changeDatas, allDatas, _this);
			}
		};
		events.push(columnChangeEvent);
	}

	return events;
}
function getEventInfo(data, type, _this, controlType) {
	var _default = {
		"load": {
			name: "on-load",
			handler: function handler() {
				_this.$emit("on-load");
			}
		},
		"change": {
			name: "on-change",
			handler: function handler() {
				_this.$emit("on-change");
			}
		},
		"currentChange": {
			name: "on-current-change",
			handler: function handler() {
				_this.$emit("on-current-change");
			}
		},
		"selectionChange": {
			name: "on-selection-change",
			handler: function handler() {
				_this.$emit("on-selection-change");
			}
		}
	};
	var eventlist = {
		"datasource": ["load", "change", "currentChange", "selectionChange"],
		"record": ["load", "change"],
		"cell": ["load", "change"]
	};
	var result = null;
	if (null != data && _default[type] && eventlist[controlType] && eventlist[controlType].indexOf(type) != -1) {
		var _defaultInfo = _default[type];
		var baseHandler = _defaultInfo.handler;
		if (typeof data == "boolean") {
			if (data === true) {
				result = {
					eventType: type,
					eventName: _defaultInfo.name,
					vueObj: _this,
					handler: baseHandler
				};
			}
		} else if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === "object") {
			var dataName = data.name;
			result = {
				eventType: type,
				vueObj: _this,
				eventName: _defaultInfo.name
			};
			if (dataName) {
				baseHandler = function baseHandler() {
					_this.$emit(dataName);
				};
				result.eventName = dataName;
			}
			//定义了handler，只执行handler 处理执行handler时，this指向为非当前组件的问题
			result.handler = typeof data.handler != "function" ? baseHandler : function () {
				data.handler.apply(_this, arguments);
			};
		}
	}
	return result;
}

/**
 * 列的值变化事件
 * @param {*} args 
 * @param {*} _this 
 */
var columnValueChange = function columnValueChange(changeDatas, allDatas, _this) {
	var columnChangeHandlers = _this[columnHandlerKey];
	var datas = changeDatas;
	// let oldDatas = args.oldResultSet.datas;
	if (datas && datas.length > 0 && columnChangeHandlers) {
		var _loop = function _loop(i, len) {
			var data = datas[i];
			var changeData = data;
			var changeKeys = Object.keys(changeData);
			if (changeKeys && changeKeys.length > 0) {
				changeKeys.forEach(function (changeKey) {
					var columnChangeHandler = columnChangeHandlers[changeKey];
					if (columnChangeHandler) {
						var newVal = changeData[changeKey];
						// const oldVal = oldDatas[i][changeKey];
						columnChangeHandler(newVal, data);
					}
				});
			}
		};

		for (var i = 0, len = datas.length; i < len; i++) {
			_loop(i, len);
		}
	}
};

var registerDsEvent = function registerDsEvent(params) {
	var vue = params.vueObj;
	if (typeof vue.$root._$registerDsEvent == 'function') {
		vue.$root._$registerDsEvent(params);
	}
	return false;
};

/*
{
	prop:{
		//属性名称
		name:'dataSource',
		//是否必填
		required:true/false,
		//默认值
		default:{},
		//校验函数
		validator:function
	},
	event:{
		//数据加载事件
		load:false/true/{
			name:'on-load',
			handler:function
		},
		//值改变事件
		change:false/true/{
			name:'on-change'
		}
	}
}
*/

function getProps(params, type) {
	var types = {
		"datasource": {
			type: Array,
			v3PropType: "datasource",
			default: []
		},
		"record": {
			type: Object,
			v3PropType: "record",
			default: {}
		},
		"cell": {
			type: [String, Number, Boolean],
			v3PropType: "cell",
			default: null
		}
	};
	var dsName = params.name;
	var typeInfo = types[type];
	var _default = params.default ? params.default : typeInfo.default;
	var props = {};
	props[dsName] = {
		type: typeInfo.type,
		v3PropType: type,
		required: params.required === true ? true : false,
		default: function (_d) {
			return function () {
				return _d;
			};
		}(_default),
		validator: typeof params.validator == "function" ? params.validator : null
	};
	return props;
}
function check(params, type) {
	if (type == "cell") return true;
	if (params && params.prop && params.prop.name) {
		return true;
	}
	return false;
}
var mixins = {
	DatasourceMixin: DatasourceMixin,
	RecordMixin: RecordMixin,
	CellMixin: CellMixin
};
exports.default = {
	mixins: mixins
};

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// resource/v3-vdk.js